<div class="toast text-white toast-custom" role="alert" aria-live="assertive" aria-atomic="true" id="warning-toast" [ngClass]="class">
    <div class="text-white" [ngClass]="class" [className]="class == 'bg-success' ? 'toast-header toast-header-success' : 'toast-header toast-header-danger'">
        <i [className]="class == 'bg-success' ? 'fas fa-info-circle fa-lg me-2 toast-icon toast-icon-success' : 'fas fa-info-circle fa-lg me-2 toast-icon toast-icon-danger'"></i>
        <strong class="me-auto toast-text">{{title}}</strong>
        <button type="button" class="btn-close toast-text toast-text-close" aria-label="Close"
            (click)="notificationRef.close()"></button>
    </div>
</div>